export const endpoints = {
    auth: {
        getCitiesByCountry: '/auth/get-cities-by-country',
        getDistrictsByCity: '/auth/get-districts-by-city',
        login: '/auth/login-user',
        register: '/auth/register-user',
        supplierApplication: '/auth/register-supplier',
        resetUserPassword: '/auth/reset-user-password',
        verifyUserResetCode: '/auth/verify-user-reset-code',
        changeUserPassword: '/auth/change-user-password',
        registerFacebookGoogle: '/auth/login-user-google-facebook',
        getContracts: '/auth/get-contracts',
        getBusinessPackages: '/auth/get-business-packages',
        registerSupplier: '/auth/register-supplier'
    },
    supplier: {
        verificationCode: 'auth/send-supplier-verification-code',
        createSupplier: '/admins/create-supplier',
        getSupplierById: '/suppliers/get-supplier-by-id/{id}',
    },
    user: {
        getUserByEmail: '/users/get-user-by-email/{email}',
        addFavoriteProduct: '/user-favorite-products',
        deleteFavoriteProduct: '/user-favorite-products/{userId}/{productId}',
        addProductBasket: '/baskets/add-product-to-basket',
        updateUserInfo: '/users/update-user',
        updatePassword: '/users/change-user-password',
        getFavorites: '/user-favorite-products',
        getUserOrders: '/orders/get-orders-by-user-id',
        getGroupedUserOrders: '/orders/get-grouped-orders-by-user-id',
        getUserSpecialCampaigns: '/special-campaigns/get-special-campaigns',
        addUserSpecialCampaign: '/special-campaigns/add-user-to-special-campaign',
        getUserBasket: '/baskets/get-user-basket',
        getLocalBasket: '/baskets/get-local-basket/{userId}',
        deleteProductBasket: '/baskets/remove-product-from-basket',
        deleteProductLocalBasket: '/baskets/remove-product-from-local-basket',
        updateProductBasket: '/baskets/update-basket',
        updateLastOrders: 'baskets/update-basket-last-orders',
        getUserById: '/users/get-user-by-id/{id}',
        addUserToDailyCampaign: '/daily-campaigns/addUserToDailyCampaign',
        getBusinessPackageById: '/users/get-business-packages-by-id/{id}'
    },
    products: {
        getAllProducts: '/products',
        getProductsByMainCategory: 'product-categories/products-by-category-id/{id}',
        getProductById: '/products/{id}',
        getProductCategory: '/product-categories',
        getAllProductSubCategories: '/product-sub-categories',
        getProductSubCategoriesByCategoryId: '/product-sub-categories/category/{id}',
        getFlashProducts: '/products/flash-products',
        getMostSellingProducts: '/products/most-sold',
        getFeaturedProducts: '/products/featured-products',
        getDailyCampaigns: '/daily-campaigns',
        getWeeklyCampaigns: '/weekly-products',
        getCompanyCampaigns: '/company-campaigns',
        searchProducts: '/products/search',
        getProductReviews: '/product-evaluations/get-product-evaluations-by-product-id/{productId}',
        getSimilarProducts: '/products/get-similar-products/{id}',
        postProductEvaluation: '/product-evaluations/create-product-evaluation',
        postSupplierEvaluation: '/supplier-evaluations/create-supplier-evaluation',
        postOrderRefund: '/refund-requests/create-refund-request',
        productsCategoryId: '/products/category/{categoryChange}',
        productsSubCategoryId: '/products/sub-category',
        getCategories: '/product-categories',
        getWeeklyCampaignsByProductId: 'weekly-products/product/{id}',
        getProductBySupplierId: '/products/supplier-get-products',
        getProductPromotion: 'promotions/{productId}',
    },
    advertises: {
        getAdvertises: '/advertises',
        getAdvertiseById: '/advertises/{id}',
        getAdvertiseProduct: 'advertise-products/advertise/{id}',
    },
    notifications: {
        getNotifications: '/notifications/get-user-notifications',
        markAsRead: '/notifications/mark-as-read',

    },
    support: {
        CreateSupports: '/support-requests/create-support-request',
    },
    updateImage: {
        updateImageSingle: '/uploads/upload-single',
        updateImageMultiple: '/uploads/upload-multiple',
    },
    campaigns: {
        dailyCampaigns: '/daily-campaigns',
        getSingleDailyCampaign: '/daily-campaigns/{id}',
        getCompanyCampaigns: '/company-campaigns',
        getCompanyCampaignsById: '/company-campaigns/supplier/{supplierId}',
        getCompanyCampaignsDetail: '/company-campaigns/{id}',
        companySubscriptions: '/campaign-subscribers/subscribe-to-campaign',
        addAUserToCompanyCampaign: '/company-campaigns/addUserToCompanyCampaign',
    },
    orders: {
        createOrder: '/orders/create-order',
        refundRequest: '/refund-requests/create-refund-request',
        getOrdersByUserId: '/orders/get-orders-by-user-id',
        getLastOrdersByUserId: '/orders/get-last-orders-by-userId',
    },
    eAcademy: {
        getSuppliers: '/ea-promotions',
        getPromotionBySupplierId: '/ea-promotions/{supplierId}',
        getPromotionByPromotionId: '/ea-promotions/promotion/{promotionId}',
        getArchs: '/archs',
        getBlogs: '/blogs',
        getSingleBlog: '/blogs/{blogId}',
        getEvents: '/events',
        getSingleEvent: '/events/{eventId}'
    },
    complain: {
        searchComplain: '/complains/search',
        allComplains: '/complains/get-all-complain-categories',
        getComplainsById: '/complains/{id}'
    },
    maps: {
        getAll: '/auth/get-maps-stores'
    },
    settings: {
        getAll: '/auth/get-settings'
    }
};

